<template>
  <Modal
    :open="props.open"
    :custom-height="'min-h-[418px] lg:h-auto'"
    :hide-footer="true"
    @close-modal="$emit('close-modal')"
  >
    <template #modal-header>
      <div class="flex flex-col text-strongest">
        <div class="flex gap-2 items-center">
          <Icon name="Info" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">Information</p>
        </div>
        <h3 class="font-semibold text-[20px] md:text-[28px]">
          {{ content?.title ?? "Additional information" }}
        </h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6 text-strongest">
        <ul v-if="content?.items?.length" class="space-y-4">
          <li v-for="(item, index) in content.items" :key="index" class="flex gap-3">
            <span class="h-2 w-2 rounded-full bg-info mt-2 shrink-0"></span>
            <div>
              <p class="font-semibold font-inter">{{ item.label }}</p>
              <p class="text-sm text-strong font-inter">{{ item.description }}</p>
            </div>
          </li>
        </ul>
        <p v-else class="text-sm text-strong font-inter">
          No additional information is available for this step.
        </p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from "vue";
import { Modal, Icon } from "@/components";
import { PURCHASE_FLOW_INFO, CHANGE_INVESTMENT_INFO, S1_QUIET_PERIOD_INFO } from "@/constants";

defineEmits(["close-modal"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  flowType: {
    type: String,
    default: "purchase",
    validator: (v) => ["purchase", "change", "quiet-period"].includes(v),
  },
  stepName: {
    type: String,
    default: null,
  },
  substepName: {
    type: String,
    default: null,
  },
});

const content = computed(() => {
  if (props.flowType === "quiet-period") return S1_QUIET_PERIOD_INFO;

  if (!props.stepName) return null;

  const contentMap = props.flowType === "change" ? CHANGE_INVESTMENT_INFO : PURCHASE_FLOW_INFO;
  const stepContent = contentMap[props.stepName];

  if (!stepContent) return null;

  if (props.substepName && stepContent.substeps?.[props.substepName]) {
    return stepContent.substeps[props.substepName];
  }

  return {
    title: stepContent.title,
    items: stepContent.items,
  };
});
</script>
